import { AgentThreadVo, api } from "@/api";
import { threadStore } from "@/store/thread";
import isEqual from "fast-deep-equal";
import useSWR from "swr";

export function useLatestThread(threadId: string) {
  useSWR<AgentThreadVo>(
    ["thread", threadId],
    async (key) => {
      const res = await api.threads.getThreadDetail(key[1] as string);
      return res.data;
    },
    {
      onSuccess(data) {
        const currentThread = threadStore.thread;

        // 只在内容真正变化时才更新 store，避免不必要的重新渲染
        if (!isEqual(currentThread, data)) {
          threadStore.set("thread", data);
        }
      },
      refreshInterval: 5000,
    }
  );
}
